import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toggleSidebar } from '../../../../../../actions/ui';

export const SidebarToogle = () => {

    const dispatch = useDispatch();
    const { sidebarCollapsed } = useSelector(state => state.ui);

    const handleToggle = () => {
        dispatch(toggleSidebar());
    }

    return (
        <div className="nxl-navigation-toggle" style={{cursor: 'pointer'}}>
            <button type="button" onClick={handleToggle} className={`${sidebarCollapsed ? 'd-none' : ''} border-0 bg-transparent p-0`}>
                <i className="feather-align-left"></i>
            </button>
            <button type="button" className={`${sidebarCollapsed ? '' : 'd-none'} border-0 bg-transparent p-0`} onClick={handleToggle}>
                <i className="feather-arrow-right"></i>
            </button>
        </div>
    )
}
